import React, { Component } from 'react';
import { Helmet } from "react-helmet";
import PropTypes from 'prop-types';
import ShowbizPreviewHeader from './showbiz/showbiz-preview-header';
import renderPenname from './utils/renderPenname';
const ShowbizTypeNormal = (props) => {

  const {
    postContent: {
      title,
      description,
      content,
      categories,
      contentpenname,
      tags
    },
    postContent
  } = props;

  const post = postContent;

  return (
    <React.Fragment>

      <ShowbizPreviewHeader />

      <main className="position-relative">
        <div className="container">


          <div className="entry-header entry-header-1 mb-30">
            <div className="entry-meta meta-0 font-small mb-30">
              {post.primary_category &&
                <a href={`/${post.primary_category.slug}`}>
                  <span className="post-cat bg-success color-white">{post.primary_category.name}</span>
                </a>
              }
            </div>
            <h1 className="post-title mb-30">{post.title}</h1>
            <div className="entry-meta meta-1 color-grey text-uppercase">
              {post.contentpenname &&
                <React.Fragment>
                  <span className="ssf-pencil mr-2 color-black"></span><span className="post-by">{renderPenname(post.contentpenname)}</span>
                </React.Fragment>
              }

              {(post.contentsource && post.sourcename) &&
                <span>Theo: <a href={post.sourcename} target="_blank" rel="noopener noreferrer">{post.contentsource.label}</a> </span>
              }
            </div>
          </div>
          <div className="row mb-50">
            <div className="col-lg-8 col-md-12">
              <figure className="single-thumnail mb-30">
                <img src={post.img_hor} alt="" className="w-100" />
              </figure>
              <div className="single-excerpt">
                <p>{post.description}</p>
              </div>
              <div
                itemProp="articleBody"
                className="entry-main-content"
                dangerouslySetInnerHTML={{ __html: post.content }}
              />

              <div className="entry-bottom mt-50 mb-30">
                <div className="mt-2 text-right">
                  {post.contentpenname &&
                    <span className="fz16 fw-bold">
                      <span className="ssf-pencil mr-1"></span>
                      {renderPenname(post.contentpenname)}
                      {(post.contentsource && post.sourcename) &&
                        <span> - Theo: <a href={post.sourcename}>{post.contentsource.label}</a> </span>
                      }

                    </span>
                  }
                  {post.contentdesigner &&
                    <span className="fz16 fw-bold ml-4"><span className="ssf-palette"></span> {post.contentdesigner.label}</span>
                  }
                  {post.contentphoto &&
                    <span className="fz16 fw-bold ml-4"><span className="ssf-picture"></span> {post.contentphoto.label}</span>
                  }
                  {post.contentvideo &&
                    <span className="fz16 fw-bold ml-4"><span className="ssf-video"></span> {post.contentvideo.label}</span>
                  }
                </div>
                <div className="overflow-hidden mt-30 d-flex justify-content-between">
                  <div className="tags float-left text-muted mb-md-30">
                    <span className="font-small mr-10"><i className="fa fa-tag mr-5"></i>Tags: </span>

                    {post.tags && post.tags.map((tag, idx) =>
                      <a href={`/tag/${tag.slug}`} prefetch="false" key={`art-tag-${idx}`} rel="tag">{tag.label}</a>
                    )}
                  </div>
                  <div className="single-social-share float-right">
                    <ul className="d-inline-block list-inline d-flex align-items-center">
                      <li className="list-inline-item"><span className="font-small text-muted"><i className="ti-sharethis mr-5"></i>Share: </span></li>
                      <li className="list-inline-item">
                        <a className="social-icon facebook-icon text-xs-center mb-0" rel="noreferrer" title="Share on Facebook">
                          <i className="ti-facebook"></i>
                        </a>
                      </li>


                    </ul>
                  </div>
                </div>
              </div>

              <div className="row mb-30">
                <div className="col-12 col-lg text-center mb-4 mb-lg-0" id="sb-medbottom">
                  <a href="#" className="bg-white">

                    <img className="border-radius-10 d-inline" src="http://via.placeholder.com/250x250" alt="post-slider" />
                  </a>
                </div>
                <div className="col-12 col-lg text-center" id="sb-medbottom2">
                  <a href="#" className="bg-white">

                    <img className="border-radius-10 d-inline" src="http://via.placeholder.com/250x250" alt="post-slider" />
                  </a>
                </div>
              </div>


            </div>

            <div className="col-lg-4 col-md-12 sidebar-right sticky-sidebar">
              <div className="pl-lg-50 h-100">
                {/* BANNER */}
                <div className="position-sticky t--80 text-center bg-white border-radius-10 py-3" id="sb-hot">
                  <a href="#" className="bg-white" >
                    <img className="border-radius-10 d-inline" src="http://via.placeholder.com/300x600" alt="post-slider" />
                  </a>
                </div>

              </div>
            </div>

          </div>

        </div>
      </main>



    </React.Fragment>
  );
}


ShowbizTypeNormal.propTypes = {
  postContent: PropTypes.object
};


export default ShowbizTypeNormal;
